import { render } from "./uiAlert.vue?vue&type=template&id=bf0ef630&scoped=true&ts=true"
import script from "./uiAlert.vue?vue&type=script&lang=ts"
export * from "./uiAlert.vue?vue&type=script&lang=ts"

import "./uiAlert.vue?vue&type=style&index=0&id=bf0ef630&scoped=true&lang=css"

import exportComponent from "C:\\AttiTec\\DogToDo\\dev\\todo-list-vuejs-pwa-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0ef630"]])

export default __exports__